const sendEmail = ({emailObject, titleEvent}) => {
    const email_to = emailObject;
    const message_text = `<!DOCTYPE html><html lang="es"><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0"><title>Mensaje</title><style>.principal-container{width: 600px;}.header-email{background-color: #4759ab;border-radius: 24px 24px 0px 0px;}.header-email--container-banner{list-style: none;text-align: center;padding: 18px;margin: 0;}.header-email--container-banner-img{width: 121px;}.li-image{float: left;margin-left: 125px;}.info-email{padding: 15px;border: 1px solid;border-radius: 0px 0px 24px 24px;}.header-email--container-banner-img-2{width: 112px;}.button{border-radius: 4px;border: 2px solid cornflowerblue;background: aliceblue;padding: 8px;font-weight: 700;cursor: pointer !important;}</style></head><body class="mini-block"><div class="principal-container"><header class="header-email"><ul class="header-email--container-banner"><li class="li-image"><img src="https://interactiva.net.co/img_email/diabesidad/Diabesidad.png" alt="banner" class="header-email--container-banner-img"></li><li><img src="https://interactiva.net.co/img_email/diabesidad/logo-novo.png" alt="banner" class="header-email--container-banner-img"></li></ul></header><section class="info-email"><ul class="header-email--container-banner"><li><h2>¡Dr(a). ! A continuación, podrá descargar su certificado.</h2></li><li><p>Agradecemos profundamente su participación y su espera tolerante a este certificado, con su ayuda seguimos en un mejoramiento continuo.</p></li><li><a class="button" href="https://interactiva.net.co/certificados-diabesidad/index.php?name=a&mail=${encodeURIComponent(email_to)}">Descargar Certificado</a></li></ul></section></div></body></html>`;

    fetch('/api/emails', {  // Usa una ruta relativa
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            campaign_id: 28,
            name: "Novo Nordisk Colombia",
            from: "notificaciones@send.box365.com.co",
            reply_to: "soporte@interactiva.net.co",
            to: email_to,
            subject: `Registro evento ${titleEvent}`,
            body: message_text,
        }),
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(data => {
        console.log('Success:', data);
    })
    .catch(error => {
        console.error('Error:', error);
    });
};

export default sendEmail;
